"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));

var _ProductDetailPrice = _interopRequireDefault(require("@sprinx/react-com/ProductDetailPrice"));

var _Fade = _interopRequireDefault(require("@material-ui/core/Fade"));

var _ProductDetailPriceMobile = _interopRequireDefault(require("./ProductDetailPriceMobile"));

var _ProductDetailPriceDesktop = _interopRequireDefault(require("./ProductDetailPriceDesktop"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: (0, _defineProperty2.default)({
      justifyContent: 'flex-start'
    }, theme.breakpoints.down('sm'), {
      justifyContent: 'center'
    }),
    container: (0, _defineProperty2.default)({
      display: 'flex',
      flexGrow: 1
    }, theme.breakpoints.down('sm'), {
      justifyContent: 'center'
    })
  };
}, {
  name: 'ProductDetailPrice'
});

var ProductDetailPrice = /*#__PURE__*/_react.default.forwardRef(function ProductDetailPrice(_ref, ref) {
  var available = _ref.available,
      pClasses = _ref.classes,
      className = _ref.className,
      currency = _ref.currency,
      priceIsRelevant = _ref.priceIsRelevant,
      prices = _ref.prices,
      product = _ref.product,
      promoCode = _ref.promoCode,
      shipping = _ref.shipping,
      showButton = _ref.showButton,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["available", "classes", "className", "currency", "priceIsRelevant", "prices", "product", "promoCode", "shipping", "showButton"]);
  var classes = useStyles({
    classes: pClasses
  });
  var theme = (0, _styles.useTheme)();
  var mobile = (0, _useMediaQuery.default)(theme.breakpoints.down('sm'));
  var Component = mobile ? _ProductDetailPriceMobile.default : _ProductDetailPriceDesktop.default;
  return /*#__PURE__*/_react.default.createElement(_ProductDetailPrice.default, (0, _extends2.default)({}, rest, {
    className: (0, _clsx.default)(classes.root, className),
    classes: {
      productPrice: classes.container
    },
    currency: currency,
    product: product,
    ProductPriceProps: prices,
    ref: ref
  }), function (props) {
    return /*#__PURE__*/_react.default.createElement(_Fade.default, {
      in: showButton
    }, /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({}, props, {
      available: available,
      priceIsRelevant: priceIsRelevant,
      product: product,
      shipping: shipping,
      promoCode: promoCode
    })));
  });
});

process.env.NODE_ENV !== "production" ? ProductDetailPrice.propTypes = {
  available: _propTypes.default.bool,
  classes: _propTypes.default.shape({
    container: _propTypes.default.string,
    root: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  currency: _propTypes.default.string,
  priceIsRelevant: _propTypes.default.bool,
  prices: _propTypes.default.shape({}),
  product: _propTypes.default.shape({}).isRequired,
  promoCode: _propTypes.default.shape({}),
  shipping: _propTypes.default.shape({}),
  showButton: _propTypes.default.bool
} : void 0;
ProductDetailPrice.defaultProps = {
  available: undefined,
  classes: undefined,
  className: undefined,
  currency: undefined,
  priceIsRelevant: undefined,
  prices: undefined,
  shipping: undefined,
  showButton: false
};
var _default = ProductDetailPrice;
exports.default = _default;